import { maxInt } from "src/ui/utils/limit";

export const supportedLimitsDisplayedInWorkspacePage: API.Feature["feature"][] = [
    "BuildLimit",
    "CommandLimit",
    "DeviceStateHistoryLimit",
    "FDroidRepoLimit",
    "FileCountLimit",
    "FileSizeLimit",
    "GroupLimit",
    "GroupNestingLimit",
    "LicenseLimit",
    "PolicyLimit",
    "ProductLimit",
    "ProvisioningLimit",
    "StreamSessionLimit",
    "UserLimit",
];

export function isLimitReached(value: number, max: number) {
    if (max !== maxInt && max !== Infinity) {
        return max !== 0 && value >= max;
    }
    return false;
}
